import { useRef, useState } from "react";
import { motion } from "framer-motion";
import { Volume2, VolumeX } from "lucide-react";

export default function FeatureVideo() {
  const videoRef = useRef(null);
  const [muted, setMuted] = useState(true);

  const toggleMute = () => {
    const v = videoRef.current;
    if (!v) return;
    v.muted = !v.muted;
    setMuted(v.muted);
    v.play().catch(() => {});
  };

  return (
    <section data-testid="feature-video-section" className="relative py-16 md:py-24">
      <div className="mx-auto max-w-6xl px-6 md:px-10">
        <motion.div
          initial={{ y: 40, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          data-testid="feature-video-frame"
          className="relative rounded-[28px] overflow-hidden border border-white/10 bg-black"
          style={{
            aspectRatio: "16 / 9",
            boxShadow:
              "0 40px 90px -30px rgba(230,0,126,0.4), 0 30px 60px -30px rgba(0,166,230,0.4), 0 10px 30px -10px rgba(0,0,0,0.8)",
          }}
        >
          <div className="absolute -top-24 -left-16 w-72 h-72 rounded-full bg-[#E6007E]/25 blur-[120px] pointer-events-none z-0" />
          <div className="absolute -bottom-24 -right-16 w-72 h-72 rounded-full bg-[#00A6E6]/25 blur-[120px] pointer-events-none z-0" />
          <video
            ref={videoRef}
            src="/showcase/lindafarrow-feature.mp4?v=2"
            poster="/showcase/lindafarrow-poster.jpg"
            autoPlay
            muted={muted}
            loop
            playsInline
            preload="metadata"
            aria-label="Paigez.ai interactive digital magazine demo"
            className="relative z-[1] h-full w-full object-cover"
          />
          <button
            type="button"
            onClick={toggleMute}
            data-testid="feature-video-mute-toggle"
            aria-label={muted ? "Unmute video" : "Mute video"}
            className="absolute bottom-4 right-4 z-10 inline-flex items-center justify-center h-11 w-11 rounded-full bg-black/60 backdrop-blur border border-white/15 text-white hover:bg-black/80 transition-colors"
          >
            {muted ? <VolumeX size={18} /> : <Volume2 size={18} />}
          </button>
        </motion.div>
      </div>
    </section>
  );
}
